<template>
  <!-- Modal -->
  <b-modal
    id="video-modal"
    size="lg"
    hide-header
    hide-footer
    modal-class="video-modal"
  >
    <div class="video-modal-wrapper">
      <div class="video-section">
        <b-embed
          type="iframe"
          aspect="16by9"
          id="video-modal-video"
          :src="videoUrl"
          allowfullscreen
          allow="autoplay; geolocation; microphone; camera"
        ></b-embed>
      </div>
      <!-- <div class="video-modal-right">
        <div class="video-modal-user">
          <div class="dp">
            <img src="https://placeimg.com/50/50/person" alt="" srcset="" />
          </div>
          <div class="fl">
            <div class="name">User Name</div>
            <div class="details">
              15 May 2019 10:15 AM
            </div>
          </div>
        </div>
        <ul class="comment-section">
          <li v-for="i in 20" :key="i">
            <span class="user"> User{{ i }} </span>
            <span>: </span>
            <span>Lorem ipsum dolor sit amet.</span>
          </li>
        </ul>
      </div> -->
      <!-- Playlist -->
      <div class="video-modal-right" v-if="showPlayList">
        <Playlist
          :playlist="getSelectedCourse.videos"
          @playVideo="UpdateVideo"
          :isSubscribed="isSubscribed"
        />
      </div>
      <!-- Playlist -->
    </div>
  </b-modal>
  <!-- Modal -->
</template>

<script>
import { mapGetters } from "vuex";
import Playlist from "@/components/Templates/Playlist.vue";
export default {
  name: "video-modal",
  components: {
    Playlist
  },
  computed: {
    ...mapGetters("courses", ["getSelectedCourse"])
  },
  props: {
    videoUrl: String,
    showPlayList: Boolean,
    isSubscribed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    UpdateVideo(videoUrl) {
      this.videoUrl = videoUrl;
    }
  },
  mounted() {
    this.$root.$on("bv::modal::show", () => {
      //  for video modal right side height calc

      setTimeout(function() {
        if (document.querySelector(".video-modal-wrapper")) {
          let videoMoalHeight = document.getElementById("video-modal-video")
            .offsetHeight;
          document.querySelector(".video-modal-right .vb").style.height =
            videoMoalHeight + "px";
        }
      }, 100);
    });
  }
};
</script>

<style></style>
